import React, { useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import MiraIframe from "./MiraIframe";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MiraLearnMoreModal from "./MiraLearnMoreModal";
import ErrorModal from "../Security/ErrorModal"
import { width } from "@amcharts/amcharts4/.internal/core/utils/Utils";

Modal.setAppElement('#root');

const SyncMiraDevice = ({
  isOpen,
  onClose,
  email,
  userInfo,
  deviceType,
  miraConsent,
  miraLoginURL,
  MiraLearnmore,
  token
}) => {
  const [showIframe, setShowIframe] = useState(false);
  const [showLearnMoreModal, setShowLearnMoreModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleConsent = async (consentValue) => {
    setLoading(true);
    const params = {
      EmailID: email,
      AppUserId: userInfo.userData.AppUserId,
      DeviceType: deviceType,
      Consent: consentValue
    };
    try {
      const response = await axios.post(
        Endpoints.SaveMiraDataSyncConsent,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (consentValue === "N") {
        //setShowModal(true);
        setShowLearnMoreModal(true);
        //setModalMessage(response.data?.resultText);
        onClose();
      }
      else {
        if (miraConsent === "N" && response.data?.result === 1) {
          if (miraLoginURL.includes("https://")) {
            // Open Mira login in a new tab instead of showing iframe
            window.open(miraLoginURL, '_blank', 'noopener,noreferrer');
            onClose();
          } else {
            setShowModal(true);
            setModalMessage(response.data?.resultText);
            onClose();
          }
        } else if (miraConsent === "Y" && response.data?.result === 1) {
          setShowModal(true);
          setModalMessage("Mira details have been successfully synced.");
          onClose();
        } else {
          onClose();
        }
      }
    } catch (error) {
      onClose();
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  // Consent modal
  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        className="tracker-modal-content-c"
        overlayClassName="tracker-modal-overlay"
        shouldCloseOnOverlayClick={false}
        style={{width:"350px"}}
      >
       
        <p style={{ marginTop: "3rem", marginBottom: "3rem", textAlign: "center", fontSize:"1.2rem" }}>
          Are you sure you want to sync your Mira device?
                  </p>
        <div className="mb-4 row justify-content-center">
  <div className="col-6 d-flex justify-content-center">
    <button
      className="win-btn-secondary model-popup-btn w-100"
      style={{ borderRadius: "24px", fontWeight: 600 }}
      onClick={() => handleConsent("N")}
    >
      No
    </button>
    
  </div>
  <div className="col-6 d-flex justify-content-center">
    <button
      className="win-btn-primary model-popup-btn w-100"
      style={{ borderRadius: "24px", fontWeight: 600 }}
      onClick={() => handleConsent("Y")}
    >
      Yes
    </button>
  </div>
</div>
      </Modal>
      <MiraLearnMoreModal
        isOpen={showLearnMoreModal}
        onClose={() => setShowLearnMoreModal(false)}
        MiraLearnmore={MiraLearnmore}
      />
      <ErrorModal
          show={showModal}
          message={modalMessage}
          onClose={() => setShowModal(false)}
        />
    </>
  );
};

export default SyncMiraDevice;